import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { HttpFunctionResult } from "src/app/_interfaces/HttpFunctionResult";
import { TicketBase } from "src/app/_interfaces/ticket";
import { SupportAppointmentRequestConfirmation, SupportTicketConfirmation } from "./support.types";


@Injectable({
    providedIn: "root"
})
export class SupportEmployeeService{

    constructor(
        private http: HttpService
    ){}

    /**
     * Gibt alle Support-Ticket Anfragen zurück, die von Kunden erstellt wurden und auf eine Bearbeitung durch einen Mitarbeiter warten.
     * @returns 
     */
    public async getSupportTicketRequests(): Promise<HttpFunctionResult<TicketBase[]>>{
        return await this.http.GET<TicketBase[]>({
            path: "support/employee/tickets"
        })
    }

    /**
     * Lehnt eine Support-Ticket Anfrage ab
     * @param ticketId 
     * @returns 
     */
    public async rejectSupportTicketRequest(ticketId: number, rejectMessage: string): Promise<HttpFunctionResult<number>>{
        return await this.http.POST<SupportTicketConfirmation, number>({
            path: `support/employee/tickets/${ticketId}`,
            body: { accepted: false, rejectMessage }
        });
    }

    /**
     * Akzeptiert eine Support-Ticket Anfrage und weist sie den ausgewählten Mitarbeitern zu. Außerdem kann die Ticketart angepasst werden.
     * @param ticketId 
     * @param employeeIds 
     * @param ticketTypeId 
     * @returns 
     */
    public async acceptSupportTicketRequest(ticketId: number, employeeIds: number[], ticketTypeId: number): Promise<HttpFunctionResult<number>>{
        return await this.http.POST<SupportTicketConfirmation, number>({
            path: `support/employee/tickets/${ticketId}`,
            body: { accepted: true, employeeIds, ticketTypeId }
        })
    }

    /**
     * Lehnt eine Terminanfrage ab oder akzeptiert diesen. Optional kann eine Begründung oder ein neuer Terminvorschlag mitgesendet werden.
     * @param ticketId 
     * @param appointmentId 
     * @param options 
     * @returns 
     */
    public async confirmSupportAppointmentRequest(ticketId: number, appointmentId: number, options: SupportAppointmentRequestConfirmation ): Promise<HttpFunctionResult<boolean>>{
        return await this.http.POST<SupportAppointmentRequestConfirmation, boolean>({
            path: `support/employee/tickets/${ticketId}/appointment-request/${appointmentId}`,
            body: options
        })
    }

}